import { giphyAnalytics } from 'shared/api'
import log from 'shared/util/log'
import normalizePageViewUrl from 'shared/util/normalize-page-view-urls'

export function trackPageView(trackingUrl, normalize = true) {
    if (!trackingUrl || !window.dataLayer) return
    if (normalize) {
        trackingUrl = normalizePageViewUrl(trackingUrl)
    }
    if (trackingUrl) {
        log.debug(`trackPageView virtualPageURL: ${trackingUrl}`)

        // analytics
        window.dataLayer.push({
            event: 'VirtualPageview',
            virtualPageURL: trackingUrl,
            virtualPageName: trackingUrl,
        })
    }
}

export const initGoogleAnalytics = (isEmbed = false) => {
    if (window.gaCreated) return
    window.didomiOnReady = window.didomiOnReady || []

    window.didomiOnReady.push(function(Didomi) {
        if (Didomi.getUserConsentStatusForVendor('c:googleana-jHcphUGX')) {
            window.ga(
                'create',
                'UA-38174542-1',
                isEmbed ? { cookieDomain: 'auto', cookieFlags: 'SameSite=None; Secure' } : 'auto'
            )

            window.gaCreated = true
            const { dataLayer = [] } = window
            const [firstDataLayer = {}] = dataLayer

            if (firstDataLayer.loggedInStatus === 'true') {
                window.ga('set', 'userId', firstDataLayer.userID)
                window.ga('set', 'verifiedStatus', firstDataLayer.verifiedStatus)
                window.ga('set', 'userType', firstDataLayer.userType)
            }
        }
    })
}

export const setGTADataLayer = ({ dimension, value }) => {
    // all subsequent page views will have our custom dimension
    const event = {
        [dimension]: value,
    }
    log.info('dataLayer.push', event)
    window.dataLayer.push(event)
}

export const googleAnalyticsEvent = ({ category, action, label, value = null }, isEmbed) => {
    initGoogleAnalytics(isEmbed)

    log.debug(
        `googleAnalyticsEvent category: ${category} action: ${action} label: ${label} ${value ? `value: ${value}` : ''}`
    )

    window.didomiOnReady.push(function(Didomi) {
        if (Didomi.getUserConsentStatusForVendor('c:googleana-jHcphUGX')) {
            window.ga('send', 'event', category, action, label, value)
        }
    })
}

export const giphyAnalyticsEvent = async ({ shareType, gifId }) => {
    try {
        await giphyAnalytics(shareType, gifId)
    } catch (e) {
        log.error(`Error sending giphyAnalyticsEvent ${e}`)
    }
}

export const encodeGAParams = p =>
    Object.entries(p)
        .map(kv => kv.map(encodeURIComponent).join('='))
        .join('&')

export default {
    trackPageView,
    initGoogleAnalytics,
    googleAnalyticsEvent,
}
